import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { getuser } from "../helpers/user.helper";
import { approveItemPre, deleteItemPre, listPreCadastro } from "../services/ficha.service";
import AsideLeft from "./AppAdminComponents/AsideLeft";
import NavBarNotificationBar from "./AppAdminComponents/NavBarNotificationBar";
import Footer from "../components/Footer";
import ReproveModal from "../components/PreCadastro/ReproveModal";
import LoaderStatus from "../components/common/LoaderComponent";
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";

export default function PreCadastroList() {
  const [fichaList, setFichaList] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(undefined);

  const navigate = useNavigate();

  useEffect(() => {
    let user = getuser();
    //Redireciona caso não esteja logado
    if (!user) {
      //navigate("/login");
    }

    async function fetchData() {
      await requestFichas();
    }

    fetchData();
  }, []);


  const requestFichas = async () => {
    let result = await listPreCadastro();
    if (result) setFichaList(result.data);
  };

  const handleDeleteItem = async (item) => {
    Swal.fire({
      title: "<strong>Apagar ficha</strong>",
      icon: "question",
      html: "Deseja remover a ficha? ",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim!',
      cancelButtonText: "Não",
    }).then(async (result) => {
      if (result.value) {
        await deleteItemPre(item.id);
      }
    });
  };

  const handleApproveItem = async (item) => {  

    Swal.fire({
      title: "<strong>Aprovar ficha</strong>",
      icon: "question",
      html: "Deseja aprovar a ficha? ",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim!',
      cancelButtonText: "Não",
    }).then(async (result) => {
      if (result.value) {
        await approveItemPre(item.id, item);
      }
    });
  };

  const handleReproveItem = async (item) => {
    setModalIsOpen(true);
    setSelectedData(item);
  };

  const handleCancelModal = async () => {
    setModalIsOpen(false);
  };

  const optionButtons = (rowData, column) => {
    return (
      <div>
        {
          getuser().type === "A" && (
            <div style={{ paddingRight: '5px' }}>
              <button
                style={{ marginRight: '2px' }}
                onClick={() => handleApproveItem(rowData)}
                title="Aprovar Cadastro"
                type="button"
                className="btn btn-icon btn-primary btn-sm"  >
                <i className="fa fa-thumbs-up"></i>
              </button>

              <button
                style={{ marginRight: '2px' }}
                onClick={() => navigate(`/app/pre-cadastro/${rowData.id}`)}
                title="Editar Cadastro"
                type="button"
                className="btn btn-icon btn-primary btn-sm"  >
                <i className="fa fa-edit"></i>
              </button>

              <button
                style={{ marginRight: '2px' }}
                onClick={() => handleReproveItem(rowData)}
                title="Reprovar Cadastro"
                type="button"
                className="btn btn-icon btn-warning btn-sm"  >
                <i className="fa fa-thumbs-down"></i>
              </button>


              <button
                style={{ marginRight: '2px' }}
                onClick={() => handleDeleteItem(rowData)}
                title="Apagar Cadastro"
                type="button"
                className="btn btn-icon btn-danger btn-sm"  >
                <i className="fa fa-trash"></i>
              </button>
            </div>
          )}
      </div>
    );
  };

  const statusCollumn = (rowData, column) => {
    return (
      <div>
        {
          rowData.status === "A" ? (<span className="badge badge-success" >Aprovado</span>) :
            rowData.status === "EA" ? (<span className="badge badge-primary">Em análise</span>) :
              rowData.status === "AC" ? (<span className="badge badge-success">Ativo</span>) :
                rowData.status === "I" ? (<span className="badge badge-warning">Inativo</span>) :
                  (<span class="badge badge-danger">Reprovado</span>)
        }
      </div>
    );
  };

  return (
    <>
      <ReproveModal isOpen={modalIsOpen} handleCancelModal={handleCancelModal} item={selectedData} />
      <div className="wrapper">
        {/* Navbar */}
        <nav className="main-header navbar navbar-expand navbar-white navbar-light">
          <NavBarNotificationBar />
        </nav>
        <AsideLeft option="pre-cadastro" />
        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0 text-dark">Pré Cadastros</h1>
                </div>
              </div>
            </div>
          </div>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <section className="col-lg-12 connectedSortable">
                  <div className="card">
                    <div className="card-header" style={{ cursor: "pointer" }}>
                      <div className="card-tools">
                        <ul className="nav nav-pills ml-auto">
                          <li className="nav-item">
                            <a
                              className="nav-link active"
                              href="/app/pre-cadastro/add"
                              data-toggle="tab"
                            >
                              Nova Pré Cadastro
                            </a>
                          </li>
                        </ul>
                      </div>
                      <br />
                      <div className="card-body">
                        {!fichaList ? (
                          <LoaderStatus />
                        ) : (
                          <DataTable
                            value={fichaList}
                            style={{ marginBottom: 50 }}
                            paginator
                            rows={100}
                            className="p-datatable-customers"
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros"
                            emptyMessage="Nenhum dado a listar."
                          >
                            <Column field="id" header="Código" style={{ width: '5%' }} />
                            <Column field="nome" header="Nome" filter={true} />
                            <Column field="bairro" header="Bairro" style={{ width: '8%' }} />
                            <Column field="cep" header="Cep" filter={true} style={{ width: '7%' }} />
                            <Column
                              field="cidade"
                              header="Cidade"
                              filter={true}
                            />
                            <Column
                              field="estado"
                              header="Estado"
                              filter={true}
                            />
                            <Column field="email" header="Email" filter={true} />
                            <Column
                              field="telCelular"
                              header="Celular"
                              filter={true}
                            />

                            <Column
                              style={{ width: '5%' }}
                              field="cod_cliente"
                              header="Cod. Cliente"
                              filter={true}
                            />
                            <Column field="cod_supervisor" header="Supervisor" filter={true} style={{ width: '5%' }}
                              bodyStyle={{
                                textAlign: "center",
                                overflow: "hidden",
                              }}
                            />
                            <Column
                              key="123"
                              style={{ width: '5%' }}
                              body={statusCollumn}
                              bodyStyle={{
                                textAlign: "center",
                                overflow: "hidden",
                              }}
                            />
                            <Column
                              key="123"
                              body={optionButtons}
                              bodyStyle={{
                                textAlign: "center",
                                overflow: "hidden",
                              }}
                            />
                          </DataTable>
                        )}
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div className="row"></div>
            </div>
          </section>
        </div>
        <Footer />
      </div>
    </>
  );
}
